/* eslint-disable no-unused-vars*/
import React, { useState, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getCookie } from 'helper/cookie';
import { PlusOutlined } from '@ant-design/icons';
import { Button, Row, Col, Form } from 'antd';
import { get } from 'lodash';
import TableTemplateLimit from './table';
import SearchTemplateLimit from './search.templateLimit';
import { getTemplateLimitAll } from 'api/templateLimit';
import { getLotteryTypeAll } from 'api/lotteryType';
const initialState = {
   data: [],
   isLoading: true,
   isLoadingCategory: true,
   pagination: {
      total: 0,
      showSizeChanger: false,
      defaultPageSize: 10,
      current: 1,
      limit: 10,
      offset: 0,
      search: '',
      lottery_type_id: 0
   },
   search: {
      order_by: '',
      order_type: '',
   },
};

const TemplateLimitComponents = () => {
   const isMobileView = useSelector((state) => get(state, 'device.isMobileView', false));
   const navigate = useNavigate();
   const token = getCookie('access_tokenltl');
   const [form] = Form.useForm();
   const dataUser: any = getCookie('dataUser');
   const parseDataUser = dataUser ? JSON.parse(dataUser) : null;
   const [isLoading, setIsLoading] = useState(false);
   const [data, setData] = useState([]);
   const [paginate, setPaginate] = useState<any>(initialState.pagination);
   const [dataLotteryType, setDataLotteryType] = useState<any>([])

   
   const fetchLotteryTypeMyData = useCallback(
      async (query: any) => {
         const params = {
            ids: parseDataUser?.lottery_type
         };
         try {
            const responseData = await getLotteryTypeAll({ token, params: params });
            if (responseData?.status === 200) {
               const { data } = responseData;
               setDataLotteryType(data?.data?.lottery_type);
            } else {
               setDataLotteryType([]);
            }
         } catch (error) {
         }
      },
      [token],
   );

   useMemo(() => {
      if (token && parseDataUser) {
         fetchLotteryTypeMyData(parseDataUser?.lottery_type);
      }
   }, [token]);

   const fetchTemplateLimitList = useCallback(
      async (query? : any) => {
         setIsLoading(true);
         const params = {
            limit: query?.limit ? query?.limit : paginate.limit,
            offset: query?.offset ? query?.offset : paginate.offset,
            order_by: 'id',
            order_type: 'DESC',
            total: query?.total ? query?.total : paginate.total,
            search: query?.search ? query?.search : null,
            lottery_type_id: query?.lottery_type_id ? query?.lottery_type_id : null,
         };
         try {
            const responseData = await getTemplateLimitAll({ token, params: params });
            if (responseData?.status === 200) {
               const { data } = responseData;
               setData(data?.data?.template_limit);
               setPaginate((prevState : any) => {
                  return {
                     ...prevState,
                     total: data?.data?.total,
                     last_page: (data?.data?.total / prevState.limit),
                     current: prevState.current,
                  };
               });
               setIsLoading(false);
            } else {
               setData([]);
               setPaginate(initialState.pagination);
               setIsLoading(false);
            }
         } catch (error) {
            setIsLoading(false);
         }
      },
      [paginate.limit, token],
   );

   useMemo(() => {
      if (token) {
         fetchTemplateLimitList();
      }
   }, [token, fetchTemplateLimitList]);

   const onChangePage = (e : any) => {
      const { current } = e;
      const data = form.getFieldsValue();
      const query = {
         // ...search,
         limit: paginate.limit,
         offset: paginate.limit * (current - 1),
         total: paginate.total,
         search: data?.search,
         lottery_type_id: data?.lottery_type_id,
         current: current,
         showSizeChanger: false,
      };
      setPaginate(query);
      fetchTemplateLimitList(query);
   };

   const handleSubmit = (values: any) => {
      const search = values?.search;
      const lotteryType = values?.lottery_type_id;
      const query = {
         search: search,
         lottery_type_id: lotteryType || 0
      };
      fetchTemplateLimitList(query);
   };

   const handleReset = () => {
      form.resetFields();
      setPaginate(initialState.pagination);
      fetchTemplateLimitList();
   };

   return (
      <Form
         autoComplete="off"
         onFinish={handleSubmit}
         form={form}
         initialValues={{ search: '' }}
      >
         <Row justify="end" gutter={16}>
            <Col>
               <Button
                  type="primary"
                  className="btn-add btn-border-8"
                  onClick={() => navigate('/backoffice/template_limit/create', { replace: true })}
                  size='large'
               >
                  <PlusOutlined /> เพิ่มข้อมูลเทมเพลตเลขอั้น
               </Button>
            </Col>
         </Row>
         <div className='mt-4'/>
         <Row justify="end" gutter={16} style={{ marginLeft: '7px' }}>
            <Col span={24}>
               <SearchTemplateLimit
                  form={form}
                  dataSearch={dataLotteryType}
                  handleSubmit={handleSubmit}
                  handleReset={handleReset}
               />
            </Col>
         </Row>
       
         <div className='mt-3 mb-3'/>
         <TableTemplateLimit
            isLoading={isLoading}
            data={data}
            renderData={fetchTemplateLimitList}
            pagination={paginate}
            onChangePage={onChangePage}
            navigate={navigate}
            token={token}
         />
      </Form>
   );
};

export default TemplateLimitComponents;
